import { NFLookupCatalog } from "./NFLookupCatalog";
import { AppEntities } from "../../../config/entities";
import { NFLookupCatalogColumn } from "./NFLookupCatalogColumn";
import React from "react";
import { NFLookupDocument } from "./NFLookupDocument";
interface IProps {
  title?: string;
  fieldName: string;
  required?: boolean;
  showBorder?: boolean;
  width?: number;
  selectedCatalog?: boolean;
  setSelectedCatalog?: (value: boolean) => void;
}

export const NFLookupCustomerInvoices = ({
  title,
  fieldName,
  required,
  showBorder,
  width,
  selectedCatalog,
  setSelectedCatalog,
}: IProps) => {
  const loadData = async (searchText: string | undefined) => {
    return await AppEntities.CustomerInvoices.getDataService().GetAll(
      searchText
    );
  };

  return (
    <>
      <NFLookupDocument
        fieldName={fieldName}
        title={title}
        entity={AppEntities.CustomerInvoices}
        width={width}
        serverData={loadData}
        required={required}
        showBorder={showBorder}
        selectedCatalog={selectedCatalog}
        setSelectedCatalog={setSelectedCatalog}
      >
        {/* <NFLookupCatalogColumn fieldName={"name"} caption={"Name"} /> */}
        <NFLookupCatalogColumn fieldName={"id"} caption={"id"} />
        <NFLookupCatalogColumn
          fieldName={"documentNumber"}
          caption={"documentNumber"}
        />
      </NFLookupDocument>
    </>
  );
};
